/* stylelint-disable CssSyntaxError */
<template>
  <div>
    <div class="action_right">
      <TableActions
        :actions="tabActions"
        @releaseResource="grantModal"
        @recoverResource="recoverModal"
      />
    </div>
    <div class="search-form">
      <div class="form">
        <a-form-model
          ref="form"
          :model="form"
          layout="inline"
          label-align="right"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 5 }"
        >
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item
                label="基地："
                prop="baseId"
              >
                <a-select
                  v-model="form.baseId"
                  placeholder="请选择基地"
                  allow-clear
                  show-search
                  :filter-option="filterOption"
                  @inputKeydown="inputKeydown($event, checkResource)"
                >
                  <a-select-option
                    v-for="item in baseOptions"
                    :key="item.baseId"
                  >
                    {{ item.baseName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                label="操作类型:"
                prop="operationTypeId"
              >
                <a-select
                  v-model="form.operationTypeId"
                  placeholder="请选择操作类型"
                  allow-clear
                >
                  <a-select-option
                    v-for="item in operatorTypes"
                    :key="item.operatorTypeId"
                  >
                    {{ item.operatorTypeName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                label="开通时间:"
                prop="startDate"
                style="width: 100%;"
              >
                <a-range-picker
                  v-model="form.startDate"
                  @change="onStartDate"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item
                label="产品类型:"
                prop="productTypeId"
              >
                <a-select
                  v-model="form.productTypeId"
                  placeholder="请选择产品类型"
                  allow-clear
                  show-search
                  :filter-option="filterOption"
                  @inputKeydown="inputKeydown($event, checkResource)"
                >
                  <a-select-option
                    v-for="item in productTypetions"
                    :key="item.productTypeId"
                  >
                    {{ item.productTypeName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                label="产品名称:"
                prop="productId"
              >
                <a-select
                  v-model="form.productId"
                  placeholder="请选择产品名称"
                  allow-clear
                  show-search
                  :filter-option="filterOption"
                  @inputKeydown="inputKeydown($event, checkResource)"
                >
                  <a-select-option
                    v-for="item in productNames"
                    :key="item.productId"
                  >
                    {{ item.productName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                label="到期时间:"
                prop="endDate"
              >
                <a-range-picker
                  v-model="form.endDate"
                  @change="onEndChange"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item
                label="企业名称："
                prop="enterpriseName"
              >
                <a-input
                  v-model="form.enterpriseName"
                  placeholder="请输入企业名称"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                label="代金券编号："
                prop="voucherCode"
              >
                <a-input
                  v-model="form.voucherCode"
                  placeholder="请输入代金券编号"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                label="回收时间："
                prop="recoveryDate"
              >
                <a-range-picker
                  v-model="form.recoveryDate"
                  @change="onRecoveryDate"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
    </div>
    <div class="action_right">
      <TableActions
        :actions="headerActions"
        @checkResource="checkResource"
        @resetResource="resetResource('form')"
        @importData="importTables"
        @exportResource="exportResource"
        @pullResource="pullResource"
      />
    </div>
    <div class="table">
      <a-table
        :data-source="dataSource"
        :loading="loading"
        :columns="columnsNew"
        :pagination="pagination"
        :row-key="record => record.recordId"
        :expanded-row-keys="openRowKeys"
        :scroll="{ x: 3400 }"
        style="padding: 16px 0; background-color: #fff;"
        :row-class-name="setRowClass"
        @expand="handleClickRow"
        @change="handleTableChange"
      >
        <span
          slot="actions"
          slot-scope="text, record"
        >
          <TableActions
            :actions="tableActions"
            :record="record"
            @edit="editFlowDetail(record, true)"
            @delete="deleteFlowDetail(record)"
          />
        </span>

        <template
          slot="startDate"
          slot-scope="startDate"
        >
          {{ moment(startDate).format('YYYY-MM-DD') }}
        </template>

        <template
          slot="endDate"
          slot-scope="endDate"
        >
          {{ moment(endDate).format('YYYY-MM-DD') }}
        </template>

        <template
          slot="endDate"
          slot-scope="endDate"
        >
          {{ moment(endDate).format('YYYY-MM-DD') }}
        </template>

        <template
          slot="recoveryDate"
          slot-scope="recoveryDate"
        >
          {{ recoveryDate? moment(recoveryDate).format('YYYY-MM-DD'): null }}
        </template>

        <template
          slot="subsidyAmount"
          slot-scope="text, record"
        >
          <p>
            {{ record.subsidyAmount }}
          </p>
        </template>

        <a-table
          slot="expandedRowRender"
          slot-scope="record"
          :loading="loading2"
          :columns="innerColumns"
          :data-source="record.innerData"
          :pagination="false"
          class="innerClass"
          :row-key="(item, index) => index"
        >
          <template
            slot="subNum"
            slot-scope="text, innerRecord"
          >
            {{ record.num + '-' +innerRecord.num }}
          </template>
          <template
            slot="subsidyAmount"
            slot-scope="text, innerRecord"
          >
            <p
              v-if="innerRecord.over"
              style="color: red;"
            >
              {{ innerRecord.subsidyAmount+ '(超发)' }}
            </p>
            <p v-else>
              {{ innerRecord.subsidyAmount }}
            </p>
          </template>
        </a-table>
      </a-table>

      <ReleaseResourceModal
        :visible="modalVisible"
        :init-data="initData"
        :is-edit="isEdit"
        :base-options="baseOptions"
        :product-typetions="productTypetions"
        :loading="confirmLoading"
        :edit-voucher-visible="editVoucherVisible"
        @cancel="handleCancel"
        @ok="handleOk"
      />

      <RecoverResourceModalVue
        :init-data="initData"
        :visible="recoverVisible"
        :loading="confirmLoading"
        :is-edit="isEdit"
        @cancel="handleCancel"
        @ok="handleOk"
      />
    </div>
    <ImportTables
      :visible="importVisible"
      :loading="confirmLoading"
      @importCancel="handleCancel"
      @importOk="handleOk"
    />
    <ExportTables
      :visible="exportVisible"
      :loading="confirmLoading"
      :import-options="importOptions"
      @cancel="handleCancel"
      @exportOk="exportOk"
    />
  </div>
</template>

<script>
import moment from 'moment'
import {
  queryReleaseRecords,
  queryReleaseSubRecords,
  exportReleaseRecord,
  deleteReleaseRecord,
  deleteVoucherReleaseRecord,
  pullData
} from '@/api/flowDetail.js'
import {
  queryBases,
  queryOperatorType,
  queryAllProductTypes,
  queryAllProducts
} from '@/api/common.js'
import ReleaseResourceModal from './ReleaseResourceModal.vue'
import ImportTables from './ImportTables.vue'
import ExportTables from './exportTables.vue'
import { excelDown, dateChange, filterOption, inputKeydown } from '@/utils/utils.js'
import { pagination } from '@/constants/tableSetting'

import RecoverResourceModalVue from './RecoverResourceModal.vue'

const columns = [
  {
    title: '编号',
    dataIndex: 'num',
    key: 'num',
    align: 'center'
  },
  {
    title: '基地',
    dataIndex: 'baseName',
    key: 'baseName',
    align: 'center'
  },
  {
    title: '开通时间',
    dataIndex: 'startDate',
    key: 'startDate',
    scopedSlots: { customRender: 'startDate' },
    width: '130px',
    align: 'center'
  },
  {
    title: '企业名称',
    dataIndex: 'enterpriseName',
    key: 'enterpriseName',
    width: '130px',
    align: 'center'
  },
  {
    title: '产品类型',
    dataIndex: 'productType',
    key: 'productType',
    width: '130px',
    align: 'center'
  },
  {
    title: '产品名称',
    dataIndex: 'productName',
    key: 'productName',
    width: '130px',
    align: 'center'
  },
  {
    title: '补贴金额',
    dataIndex: 'subsidyAmount',
    key: 'subsidyAmount',
    scopedSlots: { customRender: 'subsidyAmount' },
    width: '130px',
    align: 'center'
  },
  {
    title: '配比系数',
    dataIndex: 'ratio',
    key: 'ratio',
    width: '130px',
    align: 'center'
  },
  {
    title: '操作类型',
    dataIndex: 'operatorTypeName',
    key: 'operatorTypeName',
    width: '130px',
    align: 'center'
  },
  {
    title: '到期时间',
    dataIndex: 'endDate',
    key: 'endDate',
    scopedSlots: { customRender: 'endDate' },
    width: '130px',
    align: 'center'
  },
  {
    title: '云账号',
    dataIndex: 'cloudAccount',
    key: 'cloudAccount',
    align: 'center'
  },
  {
    title: '代金券编码',
    dataIndex: 'voucherCode',
    key: 'voucherCode',
    align: 'center',
    width: '180px'
  },
  {
    title: '联系人',
    dataIndex: 'contactName',
    key: 'contactName',
    align: 'center'
  },
  {
    title: '手机号码',
    dataIndex: 'contactPhone',
    key: 'contactPhone',
    width: '140px',
    align: 'center'
  },
  {
    title: '运营年度',
    dataIndex: 'operatorYear',
    key: 'operatorYear',
    align: 'center'
  },
  {
    title: '产品税率',
    dataIndex: 'taxRate',
    key: 'taxRate',
    align: 'center'
  },
  {
    title: '邮箱',
    dataIndex: 'email',
    key: 'email',
    align: 'center'
  },
  {
    title: '回收/失效时间',
    dataIndex: 'recoveryDate',
    key: 'recoveryDate',
    scopedSlots: { customRender: 'recoveryDate' },
    width: '130px',
    align: 'center'
  },
  {
    title: '均摊月份',
    dataIndex: 'sharingMonth',
    key: 'sharingMonth',
    width: '130px',
    align: 'center'
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark',
    align: 'center',
    width: '380px'
  },
  {
    title: '数据来源',
    dataIndex: 'dataSource',
    key: 'dataSource',
    width: '130px',
    align: 'center'
  },
  {
    title: '操作',
    dataIndex: 'actions',
    key: 'actions',
    width: '150px',
    fixed: 'right',
    scopedSlots: { customRender: 'actions' }
  }
]

let hasAdd = false

const innerColumns = [
  {
    title: '编号',
    dataIndex: 'num',
    key: 'num',
    align: 'center',
    scopedSlots: { customRender: 'subNum' },
    width: '200px'
  },
  { title: '补贴金额', dataIndex: 'subsidyAmount', key: 'subsidyAmount', width: '200px', scopedSlots: { customRender: 'subsidyAmount' } },
  { title: '资源包名称', dataIndex: 'resourceTypeName', key: 'resourceTypeName', width: '200px' },
  { title: '资源包归属', dataIndex: 'operatorYear', key: 'operatorYear', width: '200px' },
  { title: '配比系数', dataIndex: 'ratio', key: 'ratio' }
]
const headerActions = [
  {
    title: '查询',
    type: 'primary',
    action: 'checkResource'
  },
  {
    title: '手动拉取',
    type: 'primary',
    action: 'pullResource',
    apis: ['@baseInfo/Add_Base']
  },
  {
    title: '重置',
    action: 'resetResource',
    type: 'primary',
    ghost: true
  },
  {
    title: '导入',
    action: 'importData',
    type: 'primary',
    ghost: true,
    apis: ['@baseInfo/Add_Base']
  },
  {
    title: '导出',
    type: 'primary',
    action: 'exportResource',
    ghost: true,
    apis: ['@baseInfo/Export_Bases']

  }
]

const tabActions = [
  {
    title: '发放资源',
    type: 'primary',
    action: 'releaseResource',
    apis: ['@baseInfo/Add_Base']
  },
  {
    title: '回收资源',
    type: 'primary',
    action: 'recoverResource',
    apis: ['@baseInfo/Add_Base']
  }
]

const tableActions = [
  {
    title: '编辑',
    type: 'link',
    action: 'edit',
    apis: ['@baseInfo/Add_Base']
  },
  {
    title: '删除',
    type: 'link',
    action: 'delete',
    apis: ['@baseInfo/Add_Base']
  }
]
export default {
  components: {
    ReleaseResourceModal,
    RecoverResourceModalVue,
    ImportTables,
    ExportTables
  },
  data () {
    return {
      columns,
      tabActions,
      dataSource: [],
      loading: false,
      pagination,
      recoverVisible: false,
      baseOptions: [],
      operatorTypes: [],
      productTypetions: [],
      allProductTypes: [],
      productNames: [],
      fromStartDate: null, // 开通起始时间
      toStartDate: null,
      toEndDate: null,
      fromEndDate: null,
      fromrecoveryDate: null,
      toRecoveryDate: null,
      dateFormat: 'YYYY/MM/DD',
      monthFormat: 'YYYY/MM',
      tableActions,
      headerActions,
      innerData: [], // 额外展开的行
      innerColumns,
      form: {
        baseId: undefined,
        operationTypeId: undefined,
        productTypeId: undefined,
        productId: undefined,
        enterpriseName: undefined,
        voucherCode: undefined,
        fromStartDate: undefined,
        toStartDate: undefined,
        toEndDate: undefined,
        fromEndDate: undefined,
        fromRecoveryDate: undefined,
        toRecoveryDate: undefined,
        recoveryDate: [],
        endDate: [],
        startDate: [],
        taxRate: undefined,
        remark: undefined
      },
      initData: {
        startDate: null,
        endDate: null,
        recoveryDate: null,
        enterpriseName: null,
        baseId: undefined,
        baseName: undefined,
        productTypeId: undefined,
        taxRate: null,
        remark: null,
        cloudAccount: null,
        email: null,
        contactName: null,
        contactPhone: null,
        productId: null,
        subsidyAmount: null,
        businessLicense: null,
        voucherCode: null
      },
      isEdit: false,
      modalVisible: false,
      confirmLoading: false,
      editVoucherVisible: false,
      importVisible: false,
      exportVisible: false,
      expandedRowKeys: [],
      loading2: true,
      openRowKeys: [],
      importOptions: undefined
    }
  },
  computed: {
    columnsNew () {
      const columnsTemp = columns
      if (this.$store.state.userInfo.roleType === 1 && hasAdd === false) {
        hasAdd = true
        columnsTemp.splice(columns.length - 1, 0, {
          title: '外采金额',
          dataIndex: 'externalProcurementAmount',
          key: 'externalProcurementAmount',
          align: 'center',
          width: '120px'
        },
        {
          title: '已付款金额',
          dataIndex: 'amountPaid',
          key: 'amountPaid',
          align: 'center',
          width: '140px'
        })
      }
      return columnsTemp
    }
  },
  created () {
    this.loading = true
    this.fetchData()
    this.fetchSearchOptions()
  },
  methods: {
    moment,
    dateChange,
    excelDown,
    filterOption,
    inputKeydown,
    async fetchData () {
      this.loading = true
      await queryReleaseRecords(
        {
          pageIndex: this.pagination.current,
          pageSize: this.pagination.pageSize,
          ...this.form
        }
      ).then((data) => {
        this.pagination.total = data.totalRecords
        this.dataSource = data.result ? data.result : []
      })
      this.loading = false
    },
    setRowClass (record, index) {
      // if (!record.subRecord) {
      //   return
      // }
      if (record.over && !record.subRecord) {
        return ['overClass', 'noExpand']
      } else if (record.over && record.subRecord) {
        return ['overClass']
      } else if (record.subsidyAmount < 0 && !record.subRecord) {
        return ['rowClass', 'noExpand']
      } else if (record.subsidyAmount < 0 && record.subRecord) {
        return ['rowClass']
      } else if (!record.over && record.subsidyAmount >= 0 && !record.subRecord) {
        return ['noExpand']
      } else {
        return ''
      }
    },
    editFlowDetail (record, isEdit) {
      this.initData = record
      this.isEdit = isEdit
      if (record.isVoucher && record.subsidyAmount >= 0) {
        // 其他类型
        this.modalVisible = true
        this.editVoucherVisible = true
      } else if (!record.isVoucher) {
        // 代金券类型
        this.modalVisible = true
        this.editVoucherVisible = false
      } else if (record.isVoucher && record.subsidyAmount < 0) {
        this.recoverVisible = true
      }
    },
    async deleteFlowDetail (record) {
      this.$confirm({
        title: '确定删除该条记录吗？',
        okText: '确认删除',
        cancelText: '取消',
        onOk: async () => {
          if (!record.isVoucher) {
            deleteReleaseRecord({
              recordId: record.recordId
            }).then((data) => {
              if (data) {
                this.$message.success('删除成功!')
                this.fetchData()
              } else {
                this.$message.error('存在关联信息，无法删除!')
              }
            })
          } else {
            deleteVoucherReleaseRecord({
              recordId: record.recordId
            }).then((data) => {
              if (data) {
                this.$message.success('删除成功!')
                this.fetchData()
              } else {
                this.$message.error('存在关联信息，无法删除!')
              }
            })
          }
        }
      })
    },
    pullResource () {
      pullData().then((data) => {
        if (data) {
          this.$message.success('拉取成功')
        }
      })
    },
    async checkResource () {
      this.openRowKeys = []
      this.loading = true
      this.pagination.current = 1
      await queryReleaseRecords({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.form
      }).then((data) => {
        this.dataSource = data.result ? data.result : []
        this.pagination.total = data.totalRecords
      })
      this.loading = false
    },
    async fetchSearchOptions () {
      await queryBases().then((data) => {
        this.baseOptions = data
      })
      await queryOperatorType().then((data) => {
        this.operatorTypes = data
      })
      await queryAllProductTypes().then((data) => {
        this.productTypetions = data
      })
      await queryAllProducts().then((data) => {
        this.productNames = data
      })
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination = { ...this.pagination, ...pagination }
      this.fetchData()// 获取表格数据的接口
    },
    async handleClickRow (expanded, record, index) {
      if (expanded) {
        this.openRowKeys.push(record.recordId)
        this.loading2 = true
        await queryReleaseSubRecords({
          recordId: record.recordId
        }).then((data) => {
          record.innerData = data
        })
        this.loading2 = false
        // 展开前先清空，在赋值，只展开一行
        this.expandedRowKeys = []
        this.expandedRowKeys.push(record.recordId)
      } else {
        this.openRowKeys.pop(record.baseId + '' + record.year)
      }
      //  解决Ant Design Vue table组件固定某列(fixed)和展开某行(expandedRowRender)不能同时使用
      this.$nextTick(() => {
        setTimeout(() => {
          const element = document.querySelectorAll(`[data-row-key='${record.recordId}-extra-row']`)
          const height = element[0].getBoundingClientRect().height - 33
          element[1].childNodes[0].innerHTML = `<div style="height: ${height}px;"></div>`
        }, 0)
      })
    },
    importTables () {
      this.importVisible = true
      // this.$message.success('文件上传成功!')
      this.fetchData()
    },
    exportResource () {
      this.importOptions = [{ label: '按发放数据导出', value: '1' }, { label: '按归属数据导出', value: '2' }, { label: '按全部数据导出', value: '3' }]
      this.exportVisible = true
    },
    handleCancel () {
      this.modalVisible = false
      this.importVisible = false
      this.exportVisible = false
      this.recoverVisible = false
      this.isEdit = false
    },
    handleOk () {
      this.fetchData()
      this.handleCancel()
    },
    async exportOk (value) {
      await exportReleaseRecord({
        ...this.form,
        type: value
      }).then((data) => {
        this.excelDown(data, '资源发放详情')
        this.handleCancel()
      })
    },
    grantModal () {
      this.initData = {
        startDate: null,
        endDate: null,
        recoveryDate: null,
        enterpriseName: null,
        baseName: undefined,
        baseId: undefined,
        productTypeId: undefined,
        taxRate: null,
        remark: null,
        cloudAccount: null,
        email: null,
        contactName: null,
        contactPhone: null,
        productId: null,
        subsidyAmount: null
      }
      this.modalVisible = true
    },
    recoverModal () {
      this.initData = {
        baseId: undefined,
        productTypeId: undefined,
        date: '',
        openDate: [],
        startDate: null,
        endDate: null,
        taxIncome: undefined,
        taxRate: undefined,
        remark: undefined,
        recoveryAmount: undefined
      }
      this.recoverVisible = true
    },
    resetResource (form) {
      this.form.fromEndDate = null
      this.form.toEndDate = null
      this.form.fromStartDate = null
      this.form.toStartDate = null
      this.form.fromRecoveryDate = null
      this.form.toRecoveryDate = null
      this.$refs.form.resetFields()
    },
    onEndChange (date) {
      this.form.fromEndDate = this.dateChange(date[0])
      this.form.toEndDate = this.dateChange(date[1])
    },
    onStartDate (date) {
      this.form.fromStartDate = this.dateChange(date[0])
      this.form.toStartDate = this.dateChange(date[1])
    },
    onRecoveryDate (date) {
      this.form.fromRecoveryDate = this.dateChange(date[0])
      this.form.toRecoveryDate = this.dateChange(date[1])
    }
  }
}
</script>
<style lang="less" scoped>
.form {
  display: block;
  width: 100%;
}

.ant-form {
  width: 100%;
}

.action_right {
  display: flex;
  justify-content: flex-end;
  // margin: 10px;
}

/deep/.rowClass {
  color: red;
}

/deep/.overClass > td:nth-child(7) {
  background-color: rgba(250, 142, 2, 0.7) !important;
}

/deep/ .ant-form-item-label {
  width: 83px;
}

/deep/.innerClass .ant-table-body {
  margin-left: 535px;
}

/deep/.ant-table-row td p {
  margin-bottom: 0;
}

/deep/ .noExpand .ant-table-row-expand-icon {
  display: none;
}
</style>
